import { ApiEntityIdentifier, EntityIdentifier } from "module/entity/types";

export const transformAppEntityIdentifierToApiEntityIdentifier = (
  appEntityIdentifier: EntityIdentifier
): ApiEntityIdentifier => ({
  id: appEntityIdentifier.backendId,
  frontendId: appEntityIdentifier.id,
  type: appEntityIdentifier.type,
});
